import { render } from "./LitStep1.vue?vue&type=template&id=4edcb2dc&scoped=true"
import script from "./LitStep1.vue?vue&type=script&lang=js"
export * from "./LitStep1.vue?vue&type=script&lang=js"

import "../form.css?vue&type=style&index=0&id=4edcb2dc&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4edcb2dc"]])

export default __exports__